import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

export interface ConfigureTempoIntegrationRequest {
  apiToken: string;
}

/**
 * Configure Tempo integration with API token
 */
export const configureTempoIntegration = async (
  data: ConfigureTempoIntegrationRequest
): Promise<void> => {
  const endpoint = '/api/integrations/tempo/configure';

  await withApiErrorHandler(endpoint, ApiErrorCode.INTEGRATION_TEMPO_CONFIGURE_FAILED, () =>
    axiosInstance.post(endpoint, data)
  );
};
